import React from 'react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { finalQuestions } from '../data/audit';
export function FinalCTA() {
  return <section className="bg-navy-900 px-4 py-14 sm:px-6 sm:py-20" data-id="element-158" data-mp="c6sk7g2tg6cb">
      <div className="mx-auto w-full max-w-3xl text-center" data-id="element-159" data-mp="c83odh06bg3y">
        <h2 className="font-display text-[28px] font-bold leading-[1.15] text-cream-50 sm:text-4xl lg:text-[42px]" data-id="element-160" data-mp="84xk2ewmfz04">
          Your next complex rehab case doesn’t have to start with a{' '}
          <span className="text-gold-400" data-id="element-161" data-mp="h6dlvy9dessq">blank page.</span>
        </h2>
        <p className="mt-5 text-base leading-relaxed text-cream-100/80 sm:text-lg" data-id="element-162" data-mp="h412dgnysadk">
          You don’t need another folder full of scattered information. You need a
          repeatable way to review what matters.
        </p>

        <ul className="mt-8 space-y-2 text-left" data-id="element-163" data-mp="14uwtebklj1jr">
          {finalQuestions.map(q => <li key={q} className="rounded-xl bg-white/[0.06] px-4 py-3 text-[12px] font-extrabold uppercase leading-snug tracking-[0.06em] text-gold-300 ring-1 ring-white/10 sm:text-[13px]" data-id="element-164" data-mp="zwmt5mk0lara">
              {q}
            </li>)}
        </ul>

        <p className="mt-7 text-base text-cream-100/80 sm:text-lg" data-id="element-165" data-mp="2m341yyig2ef6">
          That’s what Dr. Karito created the Complex Rehab Case Audit™ to help
          you do.
        </p>

        <div className="mt-9 flex flex-col items-center gap-6" data-id="element-166" data-mp="2qzkpprlqeqrq">
          <CTAButton label="Get the Complex Rehab Case Audit™" subLabel="$27 one-time · Instant access · Lifetime access · 7-day guarantee" data-id="element-167" data-mp="2v2r1ferm5a5l" />
          <Countdown tone="light" data-id="element-168" data-mp="34t29ndiby5ia" />
        </div>
      </div>
    </section>;
}